import { render } from "./DemoCrudChar2Form.vue?vue&type=template&id=6d470306&scoped=true"
import script from "./DemoCrudChar2Form.vue?vue&type=script&lang=js"
export * from "./DemoCrudChar2Form.vue?vue&type=script&lang=js"

import "./DemoCrudChar2Form.vue?vue&type=style&index=0&id=6d470306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d470306"]])

export default __exports__